
























































































































































































































































import Vue from "vue";
import DonationTypeView from "@/views/DonationTypeView.vue";
import InformationView from "@/views/InformationView.vue";
import CaseView from "@/views/CaseView.vue";
import {RequestSession} from "@/interfaces/requestSession";
import {deleteRequest, ENDPOINTS, get} from "@/api/mainApi";
import {Donation} from "@/interfaces/donation/donation";
import LogoFooter from "@/components/global/LogoFooter.vue";
import DonorDetailsView from "@/views/DonorDetailsView.vue";
import DonationDetailsView from "@/views/DonationDetailsView.vue";
import PaymentDeliveryView from "@/views/PaymentDeliveryView.vue";
import SummaryView from "@/views/SummaryView.vue";
import PaymentView from "@/views/PaymentView.vue";
import PaylinkPaymentView from "@/views/PaylinkPaymentView.vue";
import SuccessView from "@/views/SuccessView.vue";
import {isInvoice, isDigitalPayment} from "@/classes/PaymentMethod";
import {Snackbar} from "@/interfaces/presentation/snackbar";
import {Dialog} from "@/interfaces/presentation/dialog";
import {SystemStatus} from "@/interfaces/system/systemStatus";
import {trackEvent} from "@/utils/pageSense";
import { SystemBanner } from '@/interfaces/system/systemBanner';
import { BasaltSystemScope } from '@/enums/basaltSystemScope';
import I18n from '@/plugins/i18n';

export default Vue.extend({

  components: {
    DonationTypeView,
    InformationView,
    CaseView,
    LogoFooter,
    DonorDetailsView,
    DonationDetailsView,
    PaymentDeliveryView,
    SummaryView,
    PaymentView,
    PaylinkPaymentView,
    SuccessView
  },
  data() {
    return {
      // TODO - rewrite availableSteps and iterate. Each step should be an object: {step: number, title: String, component: String}
      availableSteps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      stepNames: {
        0: "Loader",
        1: "DonationType",
        2: "Information",
        3: "DonationCase",
        4: "DonorDetails",
        5: "DonationDetails",
        6: "PaymentDelivery",
        7: "Summary",
        8: "Payment",
        9: "Success",
        10: "Paylink"
      },
      multipleDonationTypes: false,
      requestHasExternalAgent: false,
      requestHasOnlyOneCase: false,
      loading: true,
      sessionError: false,
      systemStatus: {
        donationGuideModule: {
          maintenanceMode: false,
          message: ""
        },
        adminModule: {
          maintenanceMode: false,
          message: ""
        }
      } as SystemStatus,
      systemBanners: [] as SystemBanner[]
    }
  },
  computed: {
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    snackbar(): Snackbar {
      return this.$store.state.snackbar
    },
    currentStep() {
      return this.$store.state.currentStep
    },
    dialog(): Dialog {
      return this.$store.state.dialog
    },
  },
  async mounted() {
    this.loading = true

    let systemStatus: SystemStatus = await this.getSystemStatus()
    this.systemStatus = systemStatus
    if (systemStatus.donationGuideModule.maintenanceMode) {
      return
    }

    await I18n.loadTranslations(I18n.getUserLanguage());

    this.systemBanners = await this.getSystemBanners();

    let requestSession: RequestSession = await this.getRequestSession(false)
    if ((this.getPaymentCodeParam() || !requestSession) && this.getSerialnumberParam() != null) {
      await this.handleDonationFromSerialnumber()
    } else {
      requestSession = await this.getRequestSession(true)
      this.setSessionInStore(requestSession)
      this.multipleDonationTypes = requestSession && requestSession.donationTypes.length > 1
      this.requestHasOnlyOneCase = requestSession && requestSession.donationCases != null && requestSession.donationCases.length == 1
      this.requestHasExternalAgent = requestSession && requestSession.externalAgent != null
      if (requestSession && requestSession.paymentResponse) {
        // set donation
        let previousDonation: Donation = await get(ENDPOINTS.DONATIONS + "/" + ENDPOINTS.SERIALNUMBER + "/" + requestSession.paymentResponse.donationSerialnumber)
        if (previousDonation) {
          this.$store.commit('updateDonation', previousDonation)
          if (previousDonation.paymentSpecification.paid) {
            // if payment is paid and show success
            this.setStep(9)
          } else {
            // else show payment view
            this.setStep(8)
          }
        }
      } else {
        this.setStep(1)
      }
    }
    this.handleCustomTheming(requestSession)
    this.loading = false
  },
  watch: {
    currentStep() {
      // when step is changed we need to make sure that the cookie RequestSession matches the one in our Store
      this.verifyRequestSessionToken()
    }
  },
  methods: {
    async handleDonationFromSerialnumber() {
      let stepSet = false;
      let serialnumber = this.getSerialnumberParam()
      let previousDonation: Donation = await get(ENDPOINTS.DONATIONS + "/" + ENDPOINTS.SERIALNUMBER + "/" + serialnumber)
      if (previousDonation) {
        this.$store.commit('updateDonation', previousDonation)
        if (previousDonation.paymentSpecification.paid) {
          // if payment is paid and show success
          this.setStep(9)
          stepSet = true
        } else {
          let paymentCode = this.getPaymentCodeParam()
          if (paymentCode) {
            this.setStep(10)
            stepSet = true
          }
          // else show payment view
          if (!stepSet) {
            location.href = '/'
          }
        }
      }

      // TODO - maybe show some sort of warning if no donation could be found
    },
    closeSnackbar() {
      this.$store.commit('setSnackbar', {active: false})
    },
    closeDialog() {
      this.$store.commit('setDialog', {active: false})
    },
    dialogActionClick() {
      this.dialog.actionClick();
      this.closeDialog()
    },
    getSerialnumberParam(): String | null {
      const queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has("serialnumber")) {
        return urlParams.get("serialnumber")
      }
      return null
    },
    getPaymentCodeParam(): String | null {
      const queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has("paymentCode")) {
        return urlParams.get("paymentCode")
      }
      return null
    },
    async getRequestSession(handleError: boolean) {
      return await get(ENDPOINTS.SESSIONS_COOKIE_REQUEST, {}, handleError)
    },
    setSessionInStore(requestSession: RequestSession) {
      this.$store.commit('updateRequestSession', requestSession)
    },
    previousStep() {
      // go back one step
      this.$store.commit('updateCurrentStep', this.currentStep - 1);
      // if step is not available -> keep going back
      while (this.availableSteps.findIndex(val => val === this.currentStep) === -1) {
        this.$store.commit('updateCurrentStep', this.currentStep - 1)
      }
      this.$nextTick(() => {
        trackEvent('Navigated to previous step: ' + this.stepNames[this.currentStep]);
      })
    },
    nextStep() {
      // go forward one step
      this.$store.commit('updateCurrentStep', this.currentStep + 1);
      // if step is not available -> keep going forward
      while (this.availableSteps.findIndex(val => val === this.currentStep) === -1) {
        this.$store.commit('updateCurrentStep', this.currentStep + 1)
      }
      this.$nextTick(() => {
        trackEvent('Navigated to next step: ' + this.stepNames[this.currentStep]);
      })
    },
    removeStep(stepToRemove: number) {
      let index = this.availableSteps.findIndex(val => val === stepToRemove);
      if (index >= 0) {
        this.availableSteps.splice(index, 1)
      }
    },
    addStep(stepToAdd: number) {
      let index = this.availableSteps.findIndex(val => val === stepToAdd);
      if (index < 0) {
        this.availableSteps.push(stepToAdd)
      }
    },
    setStep(step: number) {
      this.$store.commit('updateCurrentStep', step)
      this.$nextTick(() => {
        trackEvent('Navigated to next step: ' + this.stepNames[step]);
      })
    },
    async reset() {

      this.loading = true;

      if (this.isDigitalPayment()) {
        await deleteRequest(ENDPOINTS.PAYMENTS + "/" + ENDPOINTS.TRANSACTIONS, {
          donationId: this.donation.id
        });
      } else {
        let res = await deleteRequest(ENDPOINTS.INVOICE + "/" + ENDPOINTS.FINALIZE, {donationId: this.donation.id});
        let resetDonation = this.donation;
        resetDonation.id = null;
        this.$store.commit('updateDonation', resetDonation);
      }

      this.setStep(this.availableSteps[1]);
      this.loading = false
      this.$nextTick(() => {
        trackEvent('DonationModule was reset');
      })
    },
    isInvoice() {
      return isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isDigitalPayment() {
      return isDigitalPayment(this.donation.paymentSpecification.paymentMethod.type);
    },
    reloadLocation() {
      location.reload()
    },
    async verifyRequestSessionToken() { // makes sure token in our store has not changed from the one in our cookie
      if (!this.getPaymentCodeParam() && (this.requestSession && this.requestSession.token)) {

        let requestSession: RequestSession = await this.getRequestSession(false)
        if (requestSession && requestSession.token && requestSession.token != this.requestSession.token) {
          // if we get a response back and the token does not match we show an error
          this.sessionError = true
        }
      }
    },
    handleCustomTheming(requestSession: RequestSession) {
      if (requestSession) {
        if (requestSession.primaryColor) {
          this.$vuetify.theme.themes.light.primary = "#" + requestSession.primaryColor
        }
        if (requestSession.secondaryColor) {
          this.$vuetify.theme.themes.light.secondary = "#" + requestSession.secondaryColor
        }
        if (requestSession.accentColor) {
          this.$vuetify.theme.themes.light.accent = "#" + requestSession.accentColor
        }
        if (requestSession.showTaxInfo !== null) {
          this.$store.commit('updateShowTaxInfo', requestSession.showTaxInfo);
        }
      }
    },
    async getSystemStatus(): Promise<SystemStatus> {
      return await get(ENDPOINTS.SYSTEM_STATUS, {}, false)
    },
    async getSystemBanners(): Promise<Array<SystemBanner>> {
      return await get(ENDPOINTS.SYSTEM_BANNERS, { scope: BasaltSystemScope.DONATION_GUIDE }, false)
    },
  }
});
